import InvitationFlowPage from './InvitationFlowPage';

const InvitationFlowPageSnappt: React.FC = () => {
  return <InvitationFlowPage team="snappt" />;
};

export default InvitationFlowPageSnappt;
